import { OptlyEffects } from './optly.effect';

export const OptimizelyEffects = [OptlyEffects];

export * from './optly.effect';
